import RequestActionHelper from '@kakadu-dev/base-frontend-helpers/helpers/Redux/RequestActionHelper';
import { PARSE_FILES_ACTIONS } from "./actionTypes";
export const ParseFilesActions = {
  upload: RequestActionHelper.getActionCreatorFetch(PARSE_FILES_ACTIONS.UPLOAD)
};